// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","389":"aa822862","455":"c81af333","946":"65568695"}[chunkId] + ".chunk.js";
};